import { returnStringOrNull } from '../utils/type-check'

/**
 * Create variant image slide element.
 *
 * @param variant {object}
 *
 * @returns {string|null}
 */
const createVariantImageSlideElement = (variant) => {
  const variantTitle = variant.title
  const variantImage = variant.variant_image
  const noImageUrl = "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1000x.gif"

  if (variantTitle && variantImage && variantImage !== noImageUrl) {
    const variantImageSlideElement = `
      <product-detail-image>
        <figure style="background-image:url('${variantImage}');">

          <div class="image-holder">
            <img
                src="${variantImage}"
                loading="lazy"
                alt="${variantTitle}"
            >
          </div>
        </figure>
      </product-detail-image>
    `

    return returnStringOrNull(variantImageSlideElement)
  }

  return null
}

export { createVariantImageSlideElement }
